import { Unit } from '@models';

export interface Metric {
  value: number;
  minimum?: number;
  unit: Unit;
  id: string;
}
